const DISPLAY_BLOG_LATEST_ARTICLE_NUM = 5;

const config = {
    DISPLAY_BLOG_LATEST_ARTICLE_NUM
};
export default config;